import React from 'react'
import { map, startWith } from 'rxjs/operators'
import { actionsShell } from '../../generic/actions'

export const page$ = actionsShell.replacePage.$.pipe(
	map(React.createElement),
	startWith(null)
)
